
import {
    AutoDetectSourceLanguageConfig,
    AudioConfig,
    SpeechConfig,
    SpeechRecognizer,
    PropertyId
  } from "microsoft-cognitiveservices-speech-sdk";
  import BaseLid from "../baseLid";
import { logAzureLid } from "../../speech-service-log/log";

  /**
   * reference: @see {@link https://learn.microsoft.com/zh-tw/azure/ai-services/speech-service/language-identification?tabs=once&pivots=programming-language-javascript}
   */
  export default class AzureLid extends BaseLid {
    /**
     * @type {SpeechConfig}
     * @protected
     */
    _speechConfig;

    /**
     * @type {AudioConfig}
     * @protected
     */
    _audioConfig;

    /**
     * @type {SpeechRecognizer}
     * @protected
     */
    _recognizer;

    constructor(authorizationToken, region) {
        super();

        this._speechConfig = SpeechConfig.fromAuthorizationToken(authorizationToken, region);
        this._speechConfig.setProperty(PropertyId.SpeechServiceConnection_LanguageIdMode, 'Continuous');
    }

    static fromToken(token){
        const { region } = JSON.parse(atob(token.split(".")[1]));
        return new AzureLid(
            token,
            region
        );
    }

    start(detectionLangs){
        const autoDetectSourceLanguageConfig = AutoDetectSourceLanguageConfig.fromLanguages(detectionLangs);

        const audioConfig = AudioConfig.fromDefaultMicrophoneInput();

        this._recognizer = SpeechRecognizer.FromConfig(this._speechConfig, autoDetectSourceLanguageConfig, audioConfig);

        this._recognizer.recognizing = (_, event) => {
            logAzureLid(event.result);
            this.emit('recognizing', event.result.language);
        };

        this._recognizer.recognized = (_, event) => {
            logAzureLid(event.result);
            this.emit('recognized', event.result.language);
        };

        this._recognizer.startContinuousRecognitionAsync();
    }

    stop(){
        this._recognizer?.stopContinuousRecognitionAsync();
    }
  }
